import React from "react"
import { Box } from "@chakra-ui/react"
import Icon from "components/elements/Icon"

type Props = {
  tagLabel: string
  onRemove: () => void
}

const RemoveTagButton = ({ tagLabel, onRemove }: Props) => (
  <Box
    as="button"
    type="button"
    data-merge-tag-interactive=""
    aria-label={`Remove ${tagLabel}`}
    display="inline-flex"
    alignItems="center"
    justifyContent="center"
    flexShrink={0}
    p={0}
    minW={4}
    h={4}
    borderRadius="sm"
    color="currentColor"
    opacity={0.65}
    _hover={{ opacity: 1, bg: "blackAlpha.100" }}
    onMouseDown={(e) => {
      e.preventDefault()
      e.stopPropagation()
    }}
    onClick={(e) => {
      e.preventDefault()
      e.stopPropagation()
      onRemove()
    }}
  >
    <Icon icon="times" size={2.5} />
  </Box>
)

export default RemoveTagButton
